import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import {
  IndicatorSize,
  IndicatorType,
  indicatorIcon,
} from '@thiememeulenhoff/types';
import { tagName } from '../../helpers';
import { indicatorStyles } from './indicator.styles';

export const tag = tagName('indicator');

@customElement(tag)
export class IndicatorComponent extends TmElement {
  static override styles = indicatorStyles;

  @property({ type: String, reflect: true })
  type?: IndicatorType;

  @property({ type: String, reflect: true })
  size?: IndicatorSize = 'medium';

  get icon() {
    return this.type && indicatorIcon(this.type);
  }

  override render() {
    return html`${this.renderIcon()}<slot></slot>`;
  }

  renderIcon() {
    return this.icon && html` <a-icon name=${this.icon}></a-icon>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-indicator': IndicatorComponent;
  }
}
